module.exports = __webpack_public_path__ + "static/s-class-icon-df49cfb5be6f9f07b90d609df33b0e1d.jpg";